/**
 * Type of grade that Doctor should provide after investigation of test measurement
 */
export enum TEST_RESULT {
    NORMAL = 'Normal',
    ABNORMAL = 'Abnormal',
    CAN_NOT_COMPREHEND = 'Can not comprehend',
}
